<template>
    <by-effect>
        <template v-slot:header>
            <img src="../../../assets/images/doctor/by-effects/heart-failure.png" alt="effect image">
        </template>

        <template v-slot:content>
            <p>Виявлено в анамнезі:</p>
            <p><strong>СН I-II ступеня, куріння</strong></p>
        </template>
    </by-effect>
</template>

<script>
import ByEffect from './ByEffect';

export default {
    components : {
        'by-effect' : ByEffect
    }
}
</script>